<script>
    import mapStyles from "./map-styles"; // optional
    import { MarkerClusterer } from "@googlemaps/markerclusterer";

    let container;
    let coords;
    let map;
    let zoom = 14;
    let items;
    let markers = [];
    let _markerClusterer;
    let currencies = ["USD", "EUR", "RUB"];
    let selectedCurrency = "USD";
    let selectedType = 0;
    let selectedAmount = 1;
    let center = { lat: 43.23713184622788, lng: 76.89558501422498 };
    if (window.currentCityLocation) {
        center = window.currentCityLocation;
    } //=43.23713184622788,76.89558501422498    
    let _markersIndexes = {};

    if (coords && coords.length > 0) {
        let center = { lat: coords[0], lng: coords[1] }; //=43.23713184622788,76.89558501422498
    }
    const svgMarker = {
        path: "M31.253 38.336 24 46.495l-7.253-8.16A1 1 0 0 0 16 38H1V1h46v37H32a1 1 0 0 0-.747.336Z",
        fillColor: "blue",
        fillOpacity: 0.6,
        strokeWeight: 0,
        rotation: 0,
        scale: 2,
        anchor: new google.maps.Point(15, 30),
    };

    const shortName = (name, length) => {
        if (name.length > length) {
            name = name.substring(0, length) + '...';
        }
        return name;
    }

    const prettyPrice = (price) => {
        return new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'KZT' }).format(price)
    }
    import { onMount } from "svelte";
    $: fetch(`https://paladin.kurs.finance/punkts/`)
        .then((r) => r.json())
        .then((data) => {
            items = data;
        });
    const labels = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const infoWindow = new google.maps.InfoWindow({
        content: "",
        disableAutoPan: true,
    });
    $: if (items) {
        let _markers = [];

        items.forEach((item, i) => {
            if(item.city == 'Нур-Султан'){
                item.city == 'Астана'
            }
            if (i === 0) {
                currencies = Object.keys(item.data);
            }
            if (
                item.data[selectedCurrency][0] != 0 &&
                item.data[selectedCurrency][1] != 0
            ) {
                let markerWidth = 96;
                let markerText = item.data[selectedCurrency][0] + " / " + item.data[selectedCurrency][1];
                if (selectedAmount > 1) {
                    markerText = prettyPrice(item.data[selectedCurrency][selectedType] * selectedAmount);
                }
                if (markerText.length > 12){
                    markerWidth = 144
                    if (markerText.length > 20){
                        markerWidth = 192
                    }
                }
                const marker = new google.maps.Marker({
                    position: { lat: +item.lat, lng: +item.lng },
                    icon: {
                        anchor: new google.maps.Point(markerWidth/2, 56),
                        label: "usd",
                        url:
                            'data:image/svg+xml;utf-8, \
                        <svg width="'+markerWidth+'" height="56" fill="none" xmlns="http://www.w3.org/2000/svg">\
                        <rect width="'+markerWidth+'" height="48" rx="7" fill="%234455AE" stroke="%234455AE" stroke-width="2"/>\
                        <polygon fill="%234455AE" points="'+(markerWidth/2 - 8)+',48 '+(markerWidth/2 + 8)+',48 '+(markerWidth/2)+',56" />\
                        <text fill="white" xml:space="preserve" style="white-space:pre" font-family="Arial" font-size="12" x="'+markerWidth/2+'" y="12" text-anchor="middle" class="small">' +
                             shortName(item.name,12) +
                            '</text>\
                        <text fill="white" xml:space="preserve" style="white-space:pre" font-family="Arial" font-size="14" x="'+markerWidth/2+'" y="28" text-anchor="middle" class="small">' +
                             selectedCurrency +
                            '</text>\
                        <text fill="white" xml:space="preserve" style="white-space:pre" font-family="Arial" font-size="13" font-weight="bold" x="'+markerWidth/2+'" y="42" text-anchor="middle" class="small">' +
                            markerText + 
                            "</text>\
                        </svg>",

                    },
                    // animation: google.maps.Animation.DROP,
                    // label: ,
                });

                // markers can only be keyboard focusable when they have click listeners
                // open info window when marker is clicked
                marker.addListener("click", () => {
                    window.open(window.document.location.origin+'/site/exchange?id='+item.id, "_blank");
                    
                });
                // return marker;
                _markersIndexes[item.id] = _markers.length;
                _markers.push(marker);
            }
        });

        markers = _markers;
    }
    $: if (markers.length > 0) {
        if (_markerClusterer != undefined) {
            _markerClusterer.setMap(null);
        }

        _markerClusterer = new MarkerClusterer({ markers, map });
    }
    onMount(async () => {
        map = new google.maps.Map(container, {
            zoom,
            center,
            styles: mapStyles, // optional
        });
        window.map = map;
    });
</script>
<div class="row mb-3">
    
    <div class="col-sm-3">
        
        <div class="form-floating">
            <select
                bind:value={selectedCurrency}
                class="form-select"
                id="currency"
            >
                {#each currencies as currency}
                    <option value={currency}>
                        {currency}
                    </option>
                {/each}
            </select>
            <label for="currency">Валюта</label>
        </div>
    </div>
    <div class="col-sm-3">
        <form class="form-floating">
            <input type="number" bind:value={selectedAmount} class="form-control" id="floatingInputValue" placeholder="1">
            <label for="floatingInputValue">сумма</label>
        </form>
    </div>
    <div class="col-md-2 text-center">
        <div class="btn-group btn-group-lg" role="group" aria-label="Basic radio toggle button group">
        <input type="radio" class="btn-check" name="btnradio" bind:group={selectedType} id="btnradio1" autocomplete="off" value="0">
        <label class="btn btn-outline-primary" for="btnradio1">Купить</label>
        <input type="radio" class="btn-check" name="btnradio" bind:group={selectedType} id="btnradio2" autocomplete="off" value="1">
        <label class="btn btn-outline-primary" for="btnradio2">Продать</label>
        </div>
    </div>
</div>

<div class="full-screen" bind:this={container} />
